import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { FormikValues, useFormikContext } from 'formik';
import { FC, MouseEvent } from 'react';

interface IProps {
    name: string;
    onChange?: (event: MouseEvent<HTMLElement>, newToggle: boolean) => void;
}

const FormToggleButton: FC<IProps> = (props) => {
    const { name, onChange } = props;
    const { values, setFieldValue } = useFormikContext<FormikValues>();

    const handleAffiliation = (
        event: MouseEvent<HTMLElement>,
        newToggle: boolean,
    ) => {
        setFieldValue(name, newToggle)
        onChange?.(event, newToggle);
    };

    return (
        <Box className="toggle-btn-group">
            <ToggleButtonGroup
                value={values[name]}
                exclusive
                onChange={handleAffiliation}
                aria-label="text alignment"
            >
                <ToggleButton className="mg-r-20" type="button" value={true} aria-label="yes">
                    Yes
                </ToggleButton>
                <ToggleButton type="button" value={false} aria-label="no">
                    No
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    )
}

export default FormToggleButton